<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { presets } from "@/assets/ts/diamondFilters";

const { t } = useI18n();

const props = withDefaults(defineProps<{
  value?: any;
}>(), {
  value: null,
});

const filteredPresets = computed(() => {
  return presets.filter(preset => preset.filters.type === props.value);
});
</script>

<template>
  <div class="prose prose-sm max-w-none">
    <div v-if="value === 'earth'" class="flex flex-col text-left">
      <p class="text-black font-light text-sm leading-relaxed max-w-lg">
        Unsere Experten haben für Sie die besten Kombinationen aus Schliff, Farbe und Reinheit zusammengestellt. Bei natürlichen Diamanten setzen wir ausschließlich auf höchste Qualität:
      </p>
      <p class="text-black font-light text-sm leading-relaxed mt-4">
        • Höchste Brillanz-Schliffqualität 3x excellent<br>
        • Keine Fluoreszenz<br>
        • Laser-Inscription der Zertifikat-Nummer<br>
        • Mit GIA Zertifikat<br>
        • Echte Wertanlage, geprüfte Qualität<br>
        • Alle Diamanten sofort verfügbar
      </p>
    </div>
    <div v-else-if="value === 'lab'" class="flex flex-col text-left">
      <p class="text-black font-light text-sm leading-relaxed max-w-lg">
        Unsere Experten haben für Sie die besten Kombinationen aus Schliff, Farbe und Reinheit zusammengestellt. Bei Labordiamanten setzen wir ausschließlich auf höchste Qualität:
      </p>
      <p class="text-black font-light text-sm leading-relaxed mt-4">
        • Höchste Brillanz-Schliffqualität 3x excellent<br>
        • Keine Fluoreszenz<br>
        • Laser-Inscription der Zertifikat-Nummer<br>
        • Mit IGI Zertifikat<br>
        • Geprüfte Qualität<br>
        • Alle Diamanten sofort verfügbar
      </p>
    </div>

    <div v-if="filteredPresets.length > 0" class="mt-8 w-full">
      <h4 class="text-xl font-bold mb-6 text-gray-900">Unsere Empfehlungen</h4>
      <div class="flex flex-wrap justify-center gap-2">
        <div
            v-for="preset in filteredPresets"
            :key="preset.qualityKey"
            class="shrink-0 w-[90px] justify-between flex flex-col items-start p-0 rounded-xl border border-gray-100 bg-white shadow-sm overflow-hidden"
        >
          <div class="flex justify-between items-start w-full px-1 pt-2 mb-3">
            <span class="w-full text-center text-sm font-bold tracking-tight text-gray-900">
              {{ t('components.diamonds.search.presets.' + preset.qualityKey + '.title') }}
            </span>
          </div>
          <p class="text-[10px] px-2 text-center w-full leading-tight text-gray-500 font-medium pb-2 mb-2 h-8 flex items-center justify-center">
            {{ t('components.diamonds.search.presets.' + preset.qualityKey + '.description') }}
          </p>

          <p class="bg-brand-main text-[10px] py-1 text-center w-full leading-tight text-white font-light">
            {{ t('components.diamonds.search.presets.' + preset.qualityKey + '.flag') }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
</style>